import React from "react";
import { X, ChevronLeft } from "lucide-react";

export default function SummaryPanel({
  panelOpen,
  setPanelOpen,
  selectedNode,
  setSelectedNode,
  palette = { panelBg: "bg-white" },
}) {
  const headerBg = "bg-gradient-to-r from-slate-50 to-white";
  const panelWidth = "clamp(250px, 28vw, 336px)";

  return (
    <div className="right-0 top-0 h-full z-50 flex items-stretch min-w-0">
      {/* Animated panel */}
      <aside
        className={`
          ${palette.panelBg}
          h-full shadow-2xl border-l border-slate-200 flex flex-col overflow-hidden
          transition-all duration-300 ease-in-out
        `}
        style={{ width: panelOpen ? panelWidth : 0, maxWidth: "100%" }}
        aria-hidden={!panelOpen}
      >
        {/* Header */}
        <div
          className={`relative flex items-center px-4 py-3 pr-12 ${headerBg} border-b border-slate-100`}
        >
          <div className="min-w-0">
            <h3 className="text-lg font-semibold leading-tight break-words [overflow-wrap:anywhere]">
              Node details
            </h3>
            <p className="text-xs text-slate-500 break-words [overflow-wrap:anywhere]">
              Inspect node metadata
            </p>
          </div>
          <button
            type="button"
            onClick={() => setPanelOpen(false)}
            aria-label="Close details panel"
            className="absolute right-5 top-0 inline-flex h-full items-center bg-transparent text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-300"
          >
            <X size={16} />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 flex-1 overflow-auto">
          {selectedNode ? (
            <div className="space-y-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <h4 className="text-sm font-medium whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
                    {selectedNode.data?.label?.replace(/\\n/g, "\n") ||
                      selectedNode.id}
                  </h4>
                  <div className="mt-1 text-xs text-slate-500 break-words [overflow-wrap:anywhere]">
                    ID:{" "}
                    <span className="font-mono text-xs text-slate-600">
                      {selectedNode.id}
                    </span>
                  </div>
                </div>
              </div>

              {selectedNode.data?.summary ? (
                <div className="bg-slate-50 border border-slate-100 rounded-md p-3">
                  <p className="font-semibold text-sm mb-2 break-words [overflow-wrap:anywhere]">
                    {selectedNode.data.summary.summary}
                  </p>
                  <pre className="whitespace-pre-wrap text-xs font-mono text-slate-700 max-h-48 overflow-auto rounded-sm bg-white p-2 border border-slate-50">
                    {selectedNode.data.summary.operations}
                  </pre>
                </div>
              ) : (
                <div className="text-slate-500">
                  No summary available for this node.
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col items-start gap-3 text-slate-500">
              <div className="break-words [overflow-wrap:anywhere]">
                Click a subgraph to expand it, and choose any node to display its summary.
              </div>
            </div>
          )}

        </div>
      </aside>

      {/* Slim opener when closed */}
      {!panelOpen && (
        <button
          onClick={() => setPanelOpen(true)}
          aria-label="Open details panel"
          className="w-10 h-full flex items-center justify-center bg-white border-l border-slate-200 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-300"
        >
          <ChevronLeft size={18} />
        </button>
      )}
    </div>
  );
}
